import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/presentation/App';
import '@/shared/i18n/config';
import { configureDependencies } from '@/di';

// Configurar Dependency Injection
configureDependencies();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
